import { ConfigNotLoadedError, LoyaltyNotSupportedError } from "../errors";
const validateConfig = (config) => {
    if (!config) {
        throw new ConfigNotLoadedError();
    }
    if (config.tiers.length === 0) {
        throw new LoyaltyNotSupportedError();
    }
};
export default validateConfig;
